var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.742708 1.60305C0 2.62531 0 4.08354 0 7C0 9.91643 0 11.3747 0.742708 12.3969C0.982574 12.7271 1.27291 13.0174 1.60305 13.2573C2.62531 14 4.08354 14 7 14C9.91643 14 11.3747 14 12.3969 13.2573C12.7271 13.0174 13.0174 12.7271 13.2573 12.3969C14 11.3747 14 9.91643 14 7C14 4.08354 14 2.62531 13.2573 1.60305C13.0174 1.27291 12.7271 0.982574 12.3969 0.742708C11.3747 0 9.91643 0 7 0C4.08354 0 2.62531 0 1.60305 0.742708C1.27291 0.982574 0.982574 1.27291 0.742708 1.60305ZM7.58333 4.66667C7.58333 4.3445 7.32216 4.08333 7 4.08333C6.67784 4.08333 6.41667 4.3445 6.41667 4.66667V6.41667H4.66667C4.3445 6.41667 4.08333 6.67784 4.08333 7C4.08333 7.32216 4.3445 7.58333 4.66667 7.58333H6.41667V9.33333C6.41667 9.65549 6.67784 9.91667 7 9.91667C7.32216 9.91667 7.58333 9.65549 7.58333 9.33333V7.58333H9.33333C9.65549 7.58333 9.91667 7.32216 9.91667 7C9.91667 6.67784 9.65549 6.41667 9.33333 6.41667H7.58333V4.66667Z",
    fill: "#721C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusMenuIcon);
export default __webpack_public_path__ + "static/media/plus-menu-icon.89800c4699950fa3aa553485da5805eb.svg";
export { ForwardRef as ReactComponent };